export const getShortDate = (dateTime: number, content: any, lang: any) => {
  const dt = new Date(dateTime)

  if (lang.includes('En')) {
    return `${
      content.months[dt.getMonth()]
    } ${dt.getDate()}, ${dt.getFullYear()}`
  } else {
    return `${dt.getDate()} ${
      content.months[dt.getMonth()]
    } ${dt.getFullYear()} ${content.dateEnd}`
  }
}
export const getDay = (date: string, content: any) => {
  const dt = new Date(date)
  const today = new Date(new Date().toDateString()).getTime()
  if (new Date(dt.toDateString()).getTime() == today)
    return `${content.today} - ${content.days[dt.getDay()]}`

  return content.days[dt.getDay()]
}
export const getTime = (date: string) => {
  const dt = new Date(date)
  return `${dt.getHours() >= 10 ? dt.getHours() : `0${dt.getHours()}`}:${
    dt.getMinutes() >= 10 ? dt.getMinutes() : `0${dt.getMinutes()}`
  }`
}

export const getStart = (date: string) => {
  const dt = new Date(date).setHours(0, 0, 0, 0)
  return dt
}

export const birthDate = (date: string, month: string, year: string) => {
  return `${+date > 10 ? date : `0${date}`}/${
    +month >= 10 ? month : `0${month}`
  }/${year}`
}

export const getDateOut = (date: string) => {
  const dt = new Date(date)

  return `${dt.getDate() >= 10 ? dt.getDate() : `0${dt.getDate()}`}.${
    dt.getMonth() + 1 >= 10 ? dt.getMonth() + 1 : `0${dt.getMonth() + 1}`
  }.${dt.getFullYear()}, ${
    dt.getHours() >= 10 ? dt.getHours() : `0${dt.getHours()}`
  }:${dt.getMinutes() >= 10 ? dt.getMinutes() : `0${dt.getMinutes()}`}:${
    dt.getSeconds() >= 10 ? dt.getSeconds() : `0${dt.getSeconds()}`
  }`
}
